import React from 'react'
import { ApiClient, ApiProvider } from 'jsonapi-react'

import Routes from 'routes'


const schema = {
  albums: {
    type: 'Album',
    relationships: {
      items: {
        type: 'AlbumItem',
      },
      createdBy: {
        type: 'User',
      },
      sharedToUsers: {
        type: 'SharedAlbum',
      },
    }
  },
  events: {
    type: 'Event',
    fields: {
      start_datetime: {
        type: 'date',
      },
      end_datetime: {
        type: 'date',
      },
    },
    relationships: {
      createdBy: {
        type: 'User',
      },
    }
  },
  compositions: {
    type: 'Composition',
    relationships: {
      createdBy: {
        type: 'User',
      },
      downloads: {
        type: 'CompositionDownload',
      },
      exportedFile: {
        type: 'File',
      },
    }
  },
  downloads: {
    type: 'CompositionDownload',
    relationships: {
      composition: {
        type: 'Composition',
      },
      file: {
        type: 'File',
      },
    }
  },
  share: {
    type: 'SharedAlbum',
  },
  items: {
    type: 'AlbumItem',
    relationships: {
      file: {
        type: 'File',
      },
      audio: {
        type: 'File',
      }
    }
  },
  files: {
    type: 'File',
  },
  upload: {
    type: 'File',
  },
  users: {
    type: 'User',
  },
}

export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:8000'
export const MEDIA_BASE_URL = (
  process.env.REACT_APP_MEDIA_BASE_URL ||
  BACKEND_BASE_URL + (process.env.REACT_APP_MEDIA_BASE_URL || '/media/')
)
export const API_BASE_URL = BACKEND_BASE_URL + (process.env.REACT_APP_API_BASE_URL || '/v1/')

const fetchWithToken = async (url, options) => {
  const token = localStorage.getItem('improvisaToken')
  if (token) {
    if ( ! options)
      options = {}

    options.headers = {
      ...options.headers,
      Authorization: `JWT ${token}`
    }
  }
  const urlParts = url.split('?')
  let newUrl = urlParts[0] + '/'
  if (urlParts.length > 1) {
    newUrl += '?' + urlParts[1]
  }

  let resFetch = null
  try {
    resFetch = await fetch(newUrl, options)

  } catch (error) {
    if (token) {
      try {
        const renewToken = await fetch(API_BASE_URL + '', {
          headers: {
            'Authorization': 'JWT ' + localStorage.getItem('improvisaRefreshToken'),
            'Content-Type': 'application/api.vnd+json',
          }
        })
        localStorage.setItem('improvisaToken', renewToken.data.access)
        localStorage.setItem('improvisaRefreshToken', renewToken.data.refresh)

      } catch (error) {
        return resFetch

      }

      options.headers = {
        ...options.headers,
        Authorization: `JWT ${localStorage.getItem('improvisaToken')}`
      }
    }

    resFetch = await fetch(newUrl, options)
  }
  return resFetch
}

export const client = new ApiClient({
  url: API_BASE_URL,
  schema,
  fetch: fetchWithToken,
})


function App() {
  return (
    <ApiProvider client={client}>
      <Routes />
    </ApiProvider>
  )
}

export default App
